export const GET_THUOC_TINH_TAI_SAN = "GET_THUOC_TINH_TAI_SAN";
export const GET_THUOC_TINH_TAI_SAN_SUCCESS = "GET_THUOC_TINH_TAI_SAN_SUCCESS";
export const GET_THUOC_TINH_TAI_SAN_FAILURE = "GET_THUOC_TINH_TAI_SAN_FAILURE";
export const GET_THUOC_TINH_TAI_SAN1 = "GET_THUOC_TINH_TAI_SAN1";
export const GET_THUOC_TINH_TAI_SAN1_SUCCESS =
  "GET_THUOC_TINH_TAI_SAN1_SUCCESS";
export const GET_THUOC_TINH_TAI_SAN1_FAILURE =
  "GET_THUOC_TINH_TAI_SAN1_FAILURE";
